import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InputBox = styled.div<{ type?: string }>`
  ${({ theme, type }) => css`
    display: block;
    position: relative;
    width: 100%;
    height: 44px;
    padding: ${type === 'password' ? '11px 48px 11px 12px' : '11px 12px'};
    overflow: hidden;
    border-radius: 8px;
    background: ${theme.backgroundColor.onelevated};

    input {
      display: block;
      width: 100%;
      color: ${theme.content.hierarchy1};
      line-height: 22px;
      ${theme.fontStyle.text.body16_medium}

      &::placeholder {
        color: ${theme.content.content_light_5};
        ${theme.content.caption2}
      }
    }
  `}
`;

export const Option = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  right: 12px;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
`;

export const CheckListWrapper = styled.div`
  display: block;
`;

export const CheckListBox = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CheckList = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;

export const CheckIcon = styled.div<{ active?: boolean }>`
  ${({ theme, active }) => css`
    display: block;
    position: relative;
    width: 14px;
    height: 14px;
    transition: 0.2s ease-in-out;
    border: 1px solid
      ${active ? theme.themeColor.main_1 : theme.content.caption1};
    border-radius: 50%;
    background: ${active ? theme.themeColor.main_1 : 'transparent'};

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: calc(50% - 1px);
      left: 50%;
      width: 5px;
      height: 3px;
      transform: translate(-50%, -50%) rotate(-45deg);
      transition: 0.2s ease-in-out;
      border-bottom: 1px solid
        ${active ? theme.content.content_dark_1 : theme.content.caption1};
      border-left: 1px solid
        ${active ? theme.content.content_dark_1 : theme.content.caption1};
    }
  `}
`;

export const Desc = styled.p`
  ${({ theme }) => css`
    display: block;
    ${theme.fontStyle.label.list12_medium}
    color: ${theme.content.caption1};
  `}
`;
